//import RoleList from "./RoleList";
import UserList from "./UserList";
import UserHistoryList from "./UserHistoryList";
import UserFormPage from "./UserFormPage"
import ConfigurationList from "./ConfigurationList";
import LogsList from "./LogsList";

const routes = [
    {path : 'administration/configuration', component: () => <ConfigurationList/>, isPublic : false, isSidebar : true, permissions:['view_criteria', 'view_units', 'view_roles']},

    {path : 'administration/activity-logs', component: () => <LogsList/>, isPublic : false, isSidebar : true},

    {path : 'administration/users', component: () => <UserList/>, isPublic : false, isSidebar : true, permissions:['view_users']},
    {path : 'administration/list', component: () => <UserList/>, isPublic : false, isSidebar : true, permissions:['view_users']},

    {path : 'administration/user/create', component: () => <UserFormPage/>, isSidebar : true, isPublic : false , permissions:['add_user']},
    {path : 'administration/create', component: () => <UserFormPage/>, isSidebar : true, isPublic : false , permissions:['add_user']},

    {path : 'administration/user/update', component: (data,type) => <UserFormPage data={data} type={type}/>, isSidebar : true, isPublic : false ,permissions:['update_user']},
    {path : 'administration/update', component: (data,type) => <UserFormPage data={data} type={type}/>, isSidebar : true, isPublic : false ,permissions:['update_user']},
    
    //{path : 'administration/role/list', component: () => <RoleList/>, isPublic : false, isSidebar : true, permissions:['view_roles']},
    {path : 'administration/user/logs', component: (data) => <UserHistoryList data={data} />, isPublic : false, isSidebar : true, permissions:['view_users']},
    {path : 'administration/logs', component: (data) => <UserHistoryList data={data} />, isPublic : false, isSidebar : true, permissions:['view_users']},
]

export default routes;
